import { render, staticRenderFns } from "./TeamRedirect.vue?vue&type=template&id=6cd82870"
import script from "./TeamRedirect.vue?vue&type=script&lang=js"
export * from "./TeamRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports